import { i18nNsFactory } from '@atlas-frontend/i18n';
import { z, ZodErrorMap } from 'zod/v3';
import { KEY_MAX_LENGTH, NAME_MAX_LENGTH } from '../../common/constants';
import { errorMap, zName, zValidPeriod } from '../../common/utils';
import translations from '../translations/RequiredKeyDataSchema.translations.json';
import validationTranslations from '../translations/validation.translations.json';

const { addTranslations, t } = i18nNsFactory('required-key-data-schema');
addTranslations(translations);
addTranslations(validationTranslations);

export const zKeyErrorMap: ZodErrorMap = (issue) => {
  if (issue.code === z.ZodIssueCode.too_big) {
    return { message: t('validation.too_big', { max: issue.maximum }) };
  }
  return { message: t('validation.key_required') };
};

export const RequiredKeyDataSchema = z.object({
  id: z.number().readonly().nullable(),
  key: z.string({ errorMap: zKeyErrorMap }).min(1).max(KEY_MAX_LENGTH),
  name: zName({ errorMap: zKeyErrorMap }).max(NAME_MAX_LENGTH).nullable(),
  description: z.string().nullable(),
  statusId: z.number().nullable(),
  sequenceNumber: z.number(),
  voluntary: z.boolean(),
  ruleTypeId: z.number().nullable(),
  validPeriod: zValidPeriod(),
  recipientIds: z
    .array(
      z.number(),
      errorMap(() => t('keys.recipients.required')),
    )
    .min(1),
  relatedAlgorithmIds: z.array(z.number()),
  selected: z.boolean().optional(),
});

export const RequiredKeyStatusDataSchema = RequiredKeyDataSchema.extend({
  statusId: z.number({
    errorMap: () => ({ message: t('keys.statusId.required') }),
  }),
});

export const RequiredKeysDataSchema = z.array(RequiredKeyDataSchema);
